export const getSummaryStyles = (
  isActive: boolean,
  isLargeScreen: boolean
) => ({
  position: "relative",
  bgcolor: "background.default",
  boxShadow: "none",
  borderRadius: "20px",
  overflow: "visible",

  padding: { xs: 3, xl: 5 },
  paddingLeft: { xs: 3, xl: 5 },
  paddingRight: { xs: 3, xl: 5 },
  paddingBottom: { xs: 2.5, xl: 5 },

  boxSizing: "border-box",
  minHeight: "100% !important",
  minWidth: {
    xs: "auto",
    lg: isActive ? "auto" : isLargeScreen ? 130 : 120,
    xl: 140,
  },
});
